import IRepresentativeRepository from 'domain/interfaces/repositories/IRepresentativeRepository'
import { CreateRepresentativeCommandRequest } from 'domain/entities/representative'

export const createRepresentativeCommand = (
  repository: IRepresentativeRepository,
  data: CreateRepresentativeCommandRequest,
) => {
  return repository.create(data)
}
